import { FormGroup, FormLabel, TextField } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Localizacao, LocalizacaoPayload } from "src/apis/eezyfamily";
import CrudDialog from "src/pages/Admin/EezyFamily/components/CrudDialog";

type Props = {
  open: boolean;
  editTarget: Localizacao | null;
  onClose: () => void;
  onSaved: () => void;
  onCreate: (p: LocalizacaoPayload) => Promise<void>;
  onUpdate: (id: number, p: LocalizacaoPayload) => Promise<void>;
};

const initialValues: LocalizacaoPayload = { city: "", state: "" };

const LocalizacaoModal: FC<Props> = ({
  open,
  editTarget,
  onClose,
  onSaved,
  onCreate,
  onUpdate,
}): JSX.Element => {
  const [form, setForm] = useState<LocalizacaoPayload>(initialValues);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(editTarget ? { city: editTarget.city, state: editTarget.state } : initialValues);
      setError("");
    }
  }, [open, editTarget]);

  const isEdit = editTarget !== null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.city.trim() || !form.state.trim()) {
      setError("Cidade e Estado são obrigatórios.");
      return;
    }
    setLoading(true);
    try {
      if (isEdit) {
        await onUpdate(editTarget.id, form);
      } else {
        await onCreate(form);
      }
      onSaved();
    } catch (err: any) {
      setError(err?.message ?? "Erro ao salvar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CrudDialog
      open={open}
      title={isEdit ? "Editar Localização" : "Nova Localização"}
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={loading}
      maxWidth="xs"
    >
      {error && (
        <div style={{ color: "red", fontSize: "0.875rem" }}>{error}</div>
      )}
      <FormGroup>
        <FormLabel required>Cidade</FormLabel>
        <TextField
          value={form.city}
          onChange={(e) => setForm((p) => ({ ...p, city: e.target.value }))}
          placeholder="Ex: São Paulo"
          autoFocus
        />
      </FormGroup>
      <FormGroup>
        <FormLabel required>Estado</FormLabel>
        <TextField
          value={form.state}
          onChange={(e) => setForm((p) => ({ ...p, state: e.target.value }))}
          placeholder="Ex: SP"
          inputProps={{ maxLength: 2 }}
        />
      </FormGroup>
    </CrudDialog>
  );
};

export default LocalizacaoModal;
